import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import DepositDoc from '../models/depositDoc';
import { BiDownload } from 'react-icons/bi';
import { FaTrash } from 'react-icons/fa';

interface IDepositDocumentManagementDialogProps {
    dialogName: string;
    clientNumber?: number;
    depositNumber?: number;
    documentList?: Array<DepositDoc>;
    addDocument?: (description: string, file: File) => void;
    deleteDocument?: (docId: number) => void;
    downloadDocument?: (doc: DepositDoc) => void;
    hideDialog: () => void;
}

const DepositDocumentManagementDialog = (props: IDepositDocumentManagementDialogProps) => {
    const { register, getValues, reset } = useForm();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedFile(e.target.files && e.target.files.length > 0 ? e.target.files[0] : null);
    };

    const handleAddDocument = () => {
        if (!selectedFile) {
            return;
        }

        const description = getValues()?.documentDescription;
        props?.addDocument?.(description, selectedFile);
        setSelectedFile(null);
        reset({ documentDescription: '' });
    };

    const handleClose = () => {
        props.hideDialog();
    };

    return (
        <Dialog title="Manage Deposit Documents" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
            <div style={{ display: 'flex', justifyContent: 'left', width: '100%' }}>
                <form style={{ width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {/* .project-billing's own table CSS sets display:block, which breaks the
                            browser's normal table column-alignment so the header/cell width
                            percentages below aren't actually held to - long Description text bleeds
                            into the File Name column instead of wrapping/truncating within its own
                            cell. Overriding back to a real table with a fixed layout (inline, so it
                            doesn't touch every other .project-billing table in the app) restores it. */}
                        <table className={'project-billing'} style={{ display: 'table', tableLayout: 'fixed', width: '100%' }}>
                            <thead style={{ textAlign: 'center' }}>
                                <tr>
                                    <th style={{ width: '35%' }}>Description</th>
                                    <th style={{ width: '25%' }}>File Name</th>
                                    <th style={{ width: '10%' }}>Type</th>
                                    <th style={{ width: '15%' }}>Date</th>
                                    <th style={{ width: '7.5%' }} />
                                    <th style={{ width: '7.5%' }} />
                                </tr>
                            </thead>
                            <tbody>
                                {props?.documentList && props.documentList.length > 0 && props.documentList.map((doc: DepositDoc, index: number) => (
                                    <tr key={doc.id ?? index} className="table-item-hover" style={{ textAlign: 'center' }}>
                                        <td
                                            title={doc.description}
                                            style={{ width: '35%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                        >
                                            {doc.description}
                                        </td>
                                        <td
                                            title={doc.originalFileName}
                                            style={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                        >
                                            {doc.originalFileName}
                                        </td>
                                        <td style={{ width: '10%' }}>{doc.documentType}</td>
                                        <td style={{ width: '15%' }}>{doc?.fileDate ? new Date(doc.fileDate).toLocaleDateString() : ''}</td>
                                        <td style={{ width: '7.5%' }}>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                                text={''}
                                                title="Download"
                                                reactIcon={BiDownload}
                                                iconHoverColor="blue"
                                                iconStyle={{ fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                                onClick={() => props?.downloadDocument(doc)}
                                            />
                                        </td>
                                        <td style={{ width: '7.5%' }}>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent' }}
                                                text={''}
                                                title="Delete"
                                                reactIcon={FaTrash}
                                                iconHoverColor="blue"
                                                iconStyle={{ fill: 'rgb(237, 53, 36)', width: '2rem', height: '2rem', verticalAlign: 'center' }}
                                                onClick={() => props?.deleteDocument(doc.id)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                {(!props?.documentList || props.documentList.length === 0) && (
                                    <tr style={{height: '2rem'}}>
                                        <td colSpan={6} style={{ textAlign: 'center' }}>No documents</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1rem' }}>
                            <RHFInputBox
                                labelOnLeft={true}
                                label={'Description'}
                                name={'documentDescription'}
                                register={register}
                                style={{ width: '100%' }}
                                bodyStyle={{ width: '50%' }}
                            />
                            <input type="file" onChange={handleFileChange} style={{ marginLeft: '1rem' }} />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '15%', marginLeft: '1rem' }}
                                text={'Add Document'}
                                disabled={!selectedFile}
                                onClick={() => handleAddDocument()}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => handleClose()}
                />
            </div>
        </Dialog>
    );
};

export default DepositDocumentManagementDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-receivable/dialogs/DepositDocumentManagementDialog.tsx